var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveTvIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17525_124023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 13,
    height: 13,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17525_124023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48802 7.85417L8.73594 6.41875C8.89844 6.31042 8.97969 6.15694 8.97969 5.95833C8.97969 5.75972 8.89844 5.60625 8.73594 5.49792L6.48802 4.0625C6.30747 3.94514 6.1224 3.93611 5.93281 4.03542C5.74323 4.13472 5.64844 4.29271 5.64844 4.50938V7.40729C5.64844 7.62396 5.74323 7.78194 5.93281 7.88125C6.1224 7.98056 6.30747 7.97153 6.48802 7.85417ZM2.66927 10.2917C2.37135 10.2917 2.11632 10.1856 1.90417 9.97344C1.69201 9.76128 1.58594 9.50625 1.58594 9.20833V2.70833C1.58594 2.41042 1.69201 2.15538 1.90417 1.94323C2.11632 1.73108 2.37135 1.625 2.66927 1.625H11.3359C11.6339 1.625 11.8889 1.73108 12.101 1.94323C12.3132 2.15538 12.4193 2.41042 12.4193 2.70833V9.20833C12.4193 9.50625 12.3132 9.76128 12.101 9.97344C11.8889 10.1856 11.6339 10.2917 11.3359 10.2917H9.16927V10.8333C9.16927 10.9868 9.11736 11.1155 9.01354 11.2193C8.90972 11.3231 8.78108 11.375 8.6276 11.375H5.3776C5.22413 11.375 5.09549 11.3231 4.99167 11.2193C4.88785 11.1155 4.83594 10.9868 4.83594 10.8333V10.2917H2.66927Z",
    fill: "#FF5F00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTvIcon);
export default __webpack_public_path__ + "static/media/LiveTvIcon.66e1c03a37cd4a3334a881112d42da8a.svg";
export { ForwardRef as ReactComponent };